(function() {
  var AngularApp,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  AngularApp = require('resources/assets/coffee/Core/AngularApplication').AngularApplication;

  exports.TestApp = (function(superClass) {
    extend(TestApp, superClass);

    TestApp.prototype.options = {
      useMap: false,
      useSidebar: true,
      useNavResize: true
    };

    function TestApp() {
      window.App = this;
      TestApp.__super__.constructor.call(this);
      this.load('core::globals/modules');
    }

    TestApp.prototype.mockService = function(methods) {
      var dummy, k, sd, v;
      if (methods == null) {
        methods = {};
      }
      sd = this.load('core::Testing/ServiceDummy');
      dummy = sd.mockService();
      for (k in methods) {
        v = methods[k];
        dummy[k] = v;
      }
      return dummy;
    };

    TestApp.prototype.mock = function(file, overrides) {
      var newobject;
      newobject = {};
      inject((function(_this) {
        return function($q) {
          var cls, item, name, okeys, ref, results;
          newobject._query = function(result) {
            var defer;
            defer = $q.defer();
            defer.resolve(result);
            return defer.promise;
          };
          for (name in overrides) {
            item = overrides[name];
            if ($.isFunction(item)) {
              item = item.bind(newobject)();
              newobject[name] = sinon.stub().returns(item);
            } else {
              newobject[name] = $.extend(true, {}, item);
            }
          }
          cls = _this.loadClass(file);
          okeys = _.keys(overrides);
          ref = cls.prototype;
          results = [];
          for (name in ref) {
            item = ref[name];
            if (indexOf.call(okeys, name) < 0) {
              if ($.isFunction(item)) {
                results.push(newobject[name] = sinon.spy());
              } else {
                results.push(void 0);
              }
            }
          }
          return results;
        };
      })(this));
      return newobject;
    };

    return TestApp;

  })(AngularApp);

}).call(this);
